<template>
  <div class="personal-info-card">
    <div class="card-header">
      <h5 class="header-title">
        <i class="icon-feather-user"></i> {{ $t('profile.member_info') }}
      </h5>
      <button class="settings-btn" :uk-tooltip="'title: ' + $t('general.update_information') + '; pos: left'" @click="$emit('closeModal')" type="button">
        <i class="icon-feather-settings"></i>
      </button>
    </div>
    <div class="divider"></div>
    <div class="card-content">
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.name') }}</h5>
        <p class="info-value">{{ userData.name }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.surname') }}</h5>
        <p class="info-value">{{ userData.surname }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('messages.dob') }}</h5>
        <p class="info-value">{{ userData.dob }}</p>
      </div>
      <div v-if="!hideEmail" class="info-item">
        <h5 class="info-label">{{ $t('profile.email') }}</h5>
        <p class="info-value info-value-ellipsis">{{ userData.email }}</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.phone') }}</h5>
        <p class="info-value">{{ userData.phone }}</p>
      </div>
    </div>
    <div class="divider"></div>
    <div class="card-content">
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.login_password') }}</h5>
        <p class="info-value">********</p>
      </div>
      <div class="info-item">
        <h5 class="info-label">{{ $t('profile.authentication_type') }}</h5>
        <p class="info-value">
          <i class="icon-feather-check"></i>
          {{ user_detail && user_detail.user && user_detail.user.authentication_type ? user_detail.user.authentication_type.name : '-' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserPersonalInfo',
  props: {
    userData: {
      type: Object,
      required: true
    },
    user_detail: {
      type: Object,
      default: null
    },
    hideEmail: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.personal-info-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
}

.header-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  display: flex;
  align-items: center;
}

.header-title i {
  font-size: 16px;
  margin-right: 6px;
}

.settings-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.settings-btn i {
  font-size: 16px;
  color: #718096;
  transition: all 0.2s ease;
}

.settings-btn:hover i {
  color: #2c3e50;
  transform: rotate(90deg);
}

.divider {
  height: 1px;
  background-color: #e2e8f0;
  margin: 0;
}

.card-content {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px;
}

.info-item {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 4px 0;
  letter-spacing: 0.3px;
}

.info-value {
  font-size: 14px;
  color: #4a5568;
  margin: 0;
  line-height: 1.5;
  word-break: break-word;
}

.info-value-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-value i.icon-feather-check {
  font-size: 14px;
  color: #28a745;
  margin-right: 4px;
}

@media (max-width: 768px) {
  .card-header {
    padding: 12px;
  }

  .header-title {
    font-size: 16px;
  }

  .card-content {
    padding: 12px;
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .info-label {
    font-size: 14px;
  }

  .info-value {
    font-size: 15px;
  }
}
</style>
